import { alpha, Box, Chip, Grid, IconButton, MenuItem, Pagination, Select, Skeleton, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import PastTourCard from "./pastTourCard";
import { ButtonComponent } from "../../components/form";
import { useState, useCallback, useEffect } from "react";
import SnackbarComponent from "../../components/snackBar/snackbarComponent";
import DialogComponent from "../../components/dialog/dialogComponent";
import { GetPastTrips } from "../../context/trip/tripProvider";
import ErrorView from "../error/errorView";
import { useNavigate } from "react-router-dom";
import { useDeleteAllToursMutation, useGetToursMutation } from "../../services/tripApi";
import { GetAuth } from "../../context/auth/authProvider";
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { VEHICLE } from "../../data/data";
import CalculatorResults from "../calculator/tour/calculatorResults";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RecordSearch from "./recordSearch";
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import subDays from 'date-fns/subDays';
import ClearIcon from '@mui/icons-material/Clear';
import { getExistingTotalRateUSD } from "../calculator/tour/tourCalculatorUtils";

const limitedDateRange = (date) => {
  const today = new Date();
  const minDate = subDays(today, 365);
  const maxDate = today;
  
  // Disable dates before the minDate or after the maxDate
  return date < minDate || date > maxDate;
};

const monthList = [
    {label: "January", value: "January"},
    {label: "February", value: "February"},
    {label: "March", value: "March"},
    {label: "April", value: "April"},
    {label: "May", value: "May"},
    {label: "June", value: "June"},
    {label: "July", value: "July"},
    {label: "August", value: "August"},
    {label: "September", value: "September"},
    {label: "October", value: "October"},
    {label: "November", value: "November"},
    {label: "December", value: "December"}
]

export const getModifiedDate = (date) => {
    date = new Date(date);
    date.setDate(date.getDate() + 1);
    return date.toISOString().split('T')[0];
}

const PastToursList = () => {
    const theme = useTheme();

    const [showDialog, setShowDialog] = useState(false);

    const [selectedFilterDateRange, setSelectedFilterDateRange] = useState(null);//[date, date]
    const [selectedFilterMonth, setSelectedFilterMonth] = useState('');
    const [searchKey, setSearchKey] = useState(null);

    const [snackBar, setSnackBar] = useState({
        message: "",
        open: false,
        color: ""
    });

    const trip = GetPastTrips();

    const navigate = useNavigate();

    const auth = GetAuth();

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(25);

    const [totalPages, setTotalPages] = useState(0);
    const [numberOfElements, setNumberOfElements] = useState(0);
    const [tripData, setTripData] = useState([]);

    const [openFilterDrawer, setOpenFilterDrawer] = useState(false);

    const [
        getAllTours,
        {
            isLoading: isLoadingTours,
            isSuccess: isSuccessEditTours,
            data: toursData,
            isError: isErrorEditTours,
            error: errorEditTours 
        }
    ] = useGetToursMutation();

    const staffId = auth?.currentUser?.staffID;

    useEffect(() => {
        if(selectedFilterDateRange && selectedFilterDateRange.length === 2){
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                fromDate: getModifiedDate(selectedFilterDateRange[0]),
                toDate: getModifiedDate(selectedFilterDateRange[1]),
                searchKey: searchKey
            });
        }
        else{
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                searchKey: searchKey
            });
        }
    }, [page, pageSize, selectedFilterMonth, staffId]);

    const loadAllTours = useCallback(() => {
        if(page > 0){
            setPage(0);
        }
        else{
            if(selectedFilterDateRange && selectedFilterDateRange.length === 2){
                getAllTours({
                    page: 0, 
                    size: pageSize, 
                    staffId,
                    month: selectedFilterMonth,
                    fromDate: getModifiedDate(selectedFilterDateRange[0]),
                    toDate: getModifiedDate(selectedFilterDateRange[1]),
                    searchKey: searchKey
                });
            }
            else{
                getAllTours({
                    page: 0, 
                    size: pageSize, 
                    staffId,
                    month: selectedFilterMonth,
                    searchKey: searchKey
                });
            }
        }
    }, [page, pageSize, selectedFilterDateRange, selectedFilterMonth, searchKey, staffId]);

    useEffect(() => {
        if(isSuccessEditTours){
            console.log("Tours...");
            console.log(toursData);

            setTotalPages(toursData.totalPages);
            setTripData(toursData.content);
            setNumberOfElements(toursData.totalElements);
        }
    }, [isSuccessEditTours, toursData]);

    useEffect(() => {
        if(isErrorEditTours){
            console.log("Tours Error...");
            console.log(errorEditTours);
        }
    }, [isErrorEditTours, errorEditTours]);

    const clearAllRequest = useCallback(() => {
        setShowDialog(true);
    }, []);

    const [
        deleteAllTours,
        {
            isLoading: isLoadingDeleteAllTours,
            isSuccess: isSuccessDeleteAllTours,
            isError: isErrorDeleteAllTours,
            error: errorDeleteAllTours
        }
    ] = useDeleteAllToursMutation();

    const clearAll = useCallback(() => {
        setShowDialog(false);

        deleteAllTours({staffId});
    }, [staffId]);

    useEffect(() => {
        if(isSuccessDeleteAllTours){
            setSnackBar({
                message: "All trips cleared successfully!",
                open: true,
                color: "green"
            });

            loadAllTours();
        }
        else if(isErrorDeleteAllTours){
            console.log("Tours Delete Error...");
            console.log(errorDeleteAllTours);

            if(errorDeleteAllTours.originalStatus === 200){
                setSnackBar({
                    message: "All trips cleared successfully!",
                    open: true,
                    color: "green"
                });

                loadAllTours();
            }
            else{
                setSnackBar({
                    message: errorDeleteAllTours?.data?.message ?? "Something went wrong",
                    open: true,
                    color: "red"
                });
            }
        }
    }, [isSuccessDeleteAllTours, isErrorDeleteAllTours, errorDeleteAllTours]);

    const changePages = useCallback((event, page) => {
        setPage(page - 1);
    }, []);

    const changePageAndSize = useCallback((newPage, newPageSize) => {
        setPage(newPage);
        setPageSize(newPageSize);
    }, []);

    const selectDateFilterRange = useCallback((value, event) => {
        if(value && value.length === 2){
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                fromDate: getModifiedDate(value[0]),
                toDate: getModifiedDate(value[1]),
                searchKey: searchKey
            });
        }
        else{
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                searchKey: searchKey
            });
        }

        setSelectedFilterDateRange(value);
    }, [page, pageSize, selectedFilterMonth, searchKey, staffId]);

    const searchWithKeywords = useCallback((keyword) => {
        if(selectedFilterDateRange && selectedFilterDateRange.length === 2){
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                fromDate: getModifiedDate(selectedFilterDateRange[0]),
                toDate: getModifiedDate(selectedFilterDateRange[1]),
                searchKey: keyword
            });
        }
        else{
            getAllTours({
                page: page, 
                size: pageSize, 
                staffId,
                month: selectedFilterMonth,
                searchKey: keyword
            });
        }
    }, [page, pageSize, selectedFilterMonth, selectedFilterDateRange, staffId]);

    const backOption =  <Stack
        direction='row'
        justifyContent='end'
        alignItems='center'
        width='100%'
        spacing={1}
        sx={{
            mb: {xs: 2, md: 0}
        }}
    >
        <ButtonComponent 
            label='New Tour'
            onClick={() => {
                navigate('/map');
            }}
            sx={{
                width: 'fit-content',
                fontWeight: 500,
                fontSize: {xs: 12, md: 16},
                letterSpacing: 0.36,
                p: {xs: 1, md: 1.5}
            }}
            variant="outlined"
            startIcon={<AddCircleIcon />}
        />
    </Stack>

    const title = <Stack
        sx={{
            width: '100%'
        }}
    >
        <Typography
            fontWeight={800}
            fontSize={{xs: 16, md: 40}}
            letterSpacing={0.36}
            color={theme.palette.primary.main}
            textAlign={{xs: 'left', md: 'center'}}
        >
            Tours
        </Typography>
    </Stack>

    let body;

    if(isLoadingTours){
        body = <Box
            px={{xs: 2, md: 7}}
            pb={{xs: 15, md: 0}}
        >
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='center'
                width='100%'
                height='100vh'
                overflow='hidden'
                py={{xs: 2, md: 9}}
            >
                {backOption}

                {title}

                <Stack
                    direction='column'
                    width='100%'
                    spacing={{xs: 1, md: 2.5}}
                    pt={{xs: 3, md: 7}}
                    pb={{xs: 1, md: 4}}
                >
                    {
                        [0,1,2].map((item, index) => {
                            return <Skeleton 
                                key={index}
                                variant="rounded" 
                                width='100%' 
                                height={80} 
                            />
                        })
                    }
                </Stack>
            </Stack>
        </Box>
    }
    else if(isErrorEditTours){
        body = <ErrorView 
            icon="/images/error.png"
            errorTitle={errorEditTours?.status ?? "Unknown Error"}
            errorDescription={errorEditTours?.data?.message ?? "Something went wrong!"}
        />
    }
    else if(isSuccessEditTours){
        body = <>
            <PastToursCardList 
                tripData={tripData}    
                loadAllTours={loadAllTours}

                clearAllRequest={clearAllRequest}
                isLoadingDeleteAllTours={isLoadingDeleteAllTours}

                totalPages={totalPages}
                page={page}
                changePages={changePages}
            />
        </>
    }
    
    return (
        <>
            <Box 
                px={{xs: 2, lg: 7}}
                pb={{xs: 15, md: 0}}
            >
                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='center'
                    width='100%'
                    py={{xs: 2, md: 9}}
                    data-aos="fade-down"
                >
                    {title}

                    {backOption}

                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                        sx={{
                            pt: {xs: 1, md: 3},
                            pb: {xs: 1, md: 4}
                        }}
                        width='100%'
                    >
                        {/* {body} */}

                        <Grid
                            direction='row'
                            width='100%'
                            spacing={{xs: 0.5, md: 1}}
                            sx={{mb: {xs: 2, md: 3}}}
                            container
                        >
                            <Grid size={{xs: 12, md: 6}}>
                                <RecordSearch
                                    searchAPICall={searchWithKeywords}
                                    setSearchKey={setSearchKey}
                                />
                            </Grid>

                            <Grid size={{xs: 6, md: 3.5}}>
                                <DateRangePicker 
                                    container={() => document.body} 
                                    preventOverflow={true}
                                    size="lg"
                                    placeholder="Select Date Range"
                                    format="MM/dd/yyyy" 
                                    character=" – "
                                    value={selectedFilterDateRange}
                                    onChange={selectDateFilterRange}
                                    showOneCalendar
                                    shouldDisableDate={limitedDateRange}
                                    block
                                />
                            </Grid>

                            <Grid size={{xs: 6, md: 2.5}}>
                               <Select
                                    labelId="demo-simple-select-autowidth-label"
                                    id="demo-simple-select-autowidth"
                                    value={selectedFilterMonth}
                                    onChange={(event) => {
                                        setSelectedFilterMonth(event.target.value);
                                    }}
                                    fullWidth
                                    sx={{
                                        height: '40px',
                                        borderRadius: '8px',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: `1px solid #666666`,
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.7)}`
                                        }
                                    }}
                                    displayEmpty
                                    renderValue={(selectedValue) => {
                                        if (selectedValue === '') {
                                            return <Typography 
                                                color="textSecondary"
                                                fontWeight={400}
                                                fontSize={16}
                                            >
                                                Select Month
                                            </Typography>
                                        }

                                        return selectedValue;
                                    }}
                                    endAdornment={
                                        selectedFilterMonth && (
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setSelectedFilterMonth('');
                                                }}
                                                sx={{
                                                    marginRight: '10px', 
                                                    pointerEvents: 'auto'
                                                }}
                                            >
                                                <ClearIcon sx={{
                                                    fontSize: 24, 
                                                    color: '#848484ff',
                                                    stroke: "#ffffff",
                                                    strokeWidth: 1   
                                                }}/>
                                            </IconButton>
                                        )
                                    }
                                >
                                    {
                                        monthList.map((item, index) => {
                                            return <MenuItem 
                                                key={index}
                                                value={item.value}
                                            >
                                                {item.label}
                                            </MenuItem>
                                        })
                                    }
                                </Select>
                            </Grid>
                        </Grid>

                        <PastToursTableList 
                            tripData={tripData}
                            dataLoading={isLoadingTours}
                            totalPages={numberOfElements}
                            page={page}
                            pageSize={pageSize}
                            changePageAndSize={changePageAndSize}

                            loadAllTours={loadAllTours}

                            clearAllRequest={clearAllRequest}
                            isLoadingDeleteAllTours={isLoadingDeleteAllTours}
                        />
                    </Stack>
                </Stack>
            </Box>

            <DialogComponent 
                open={showDialog}
                title="Clear"
                body={<>
                    <Stack
                        direction='column'
                        justifyContent='center'
                        alignItems='center'
                    >
                        <Typography
                            fontWeight={300}
                            fontSize={14}
                            textAlign='justify'
                        >
                            Are you sure to clear all the trip details?
                        </Typography>
                    </Stack>
                </>}
                handleClose={() => setShowDialog(false)}
                proceedText="No"
                cancelText="Yes"
                proceedCallback={() => setShowDialog(false)}
                cancelCallback={clearAll}
            />

            <SnackbarComponent 
                message={snackBar.message}
                color={snackBar.color}
                open={snackBar.open}
                handleClose={() => setSnackBar({
                    message: "",
                    open: false
                })}
            />
        </>
    );
}

export default PastToursList;

const PastToursCardList = ({
    tripData,
    loadAllTours,

    clearAllRequest,
    isLoadingDeleteAllTours,

    totalPages,
    page,
    changePages
}) => {
    const navigate = useNavigate();
    
    return (
        <>
            {
                tripData.length > 0
                ?
                <>
                    <Stack
                        direction='column'
                        width='100%'
                        spacing={{xs: 1, md: 2.5}}
                    >
                        {
                            tripData.map((item, index) => {
                                return <PastTourCard 
                                    key={index}
                                    data={item}
                                    loadAllTours={loadAllTours}
                                />
                            })
                        }
                    </Stack>

                    <ButtonComponent 
                        label='Clear All'
                        onClick={clearAllRequest}
                        sx={{
                            width: {xs: '100%', md: '50%'},
                            mt: {xs: 3, md: 7}
                        }}
                        variant="text"
                        inLoading={isLoadingDeleteAllTours}
                    />

                    <Stack 
                        py={{xs: 3, md: 7}}
                    >
                        <Pagination 
                            count={totalPages} 
                            page={page + 1}
                            shape="rounded" 
                            color="primary"
                            onChange={changePages}
                        />
                    </Stack>
                </>
                :
                <ErrorView 
                    icon="/images/no_trip.png"
                    errorTitle="No Tours"
                    errorDescription="Looks like you don’t have any saved tours. Try calculating a new tour and check back here when you’re ready!"
                    actionTxt="Calculate New Tour"
                    action={() => navigate('/map')}
                />
            }
        </>
    );
}

const PastToursTableList = ({
    tripData,
    dataLoading,
    totalPages,
    page,
    pageSize,
    changePageAndSize,

    loadAllTours,

    clearAllRequest,
    isLoadingDeleteAllTours
}) => {
    const [selectedTour, setSelectedTour] = useState(null);

    const getTourDetails = useCallback((id) => {
        let data = null;

        for(let i = 0; i < tripData.length; i++){
            if(tripData[i].id === id){
                data = tripData[i];
                break;
            }
        }

        return data;
    }, [tripData]);

    const viewTourDetails = useCallback((id) => {
        for(let i = 0; i < tripData.length; i++){
            if(tripData[i].id === id){
                setSelectedTour(tripData[i]);
                break;
            }
        }
    }, [tripData]);

    const columns = [
        { 
            field: 'updatedAt', 
            headerName: 'Updated On', 
            description: 'The date any changes were made to the tour\'s calculated values', 
            width: 125,
            renderCell: (params) => {
                return new Date(params.value).toLocaleDateString()
            }
        },
        { 
            field: 'tripName', 
            headerName: 'Tour Name', 
            flex: 1,
            renderCell: (params) => {
                return <Tooltip 
                    title={params?.row?.tripName}
                    enterDelay={0}
                >
                    {params?.row?.tripName}
                </Tooltip>;
            }
        },
        { 
            field: 'month', 
            headerName: 'Tour Month', 
            width: 125 
        },
        { 
            field: 'vehicle', 
            headerName: 'Vehicle', 
            width: 150,
            renderCell: (params) => {
                // Car
                if (params.value === VEHICLE[0].value) {
                    return <Chip label={params.value} size="small" sx={{backgroundColor: '#dbf6e5'}}/>;
                }
                // Flat roof van
                else if (params.value === VEHICLE[1].value) {
                    return <Chip label={params.value} size="small" sx={{backgroundColor: '#ffe4de'}}/>;
                }
                // High roof van
                else if (params.value === VEHICLE[2].value) {
                    return <Chip label={params.value} size="small" sx={{backgroundColor: '#fff1d6'}}/>;
                }
            }
        },
        { 
            field: 'days', 
            headerName: 'Tour Days', 
            width: 125 
        },
        { 
            field: '', 
            headerName: 'Total USD', 
            width: 125,
            renderCell: (params) => {
                const data = getTourDetails(params.id);

                if(data){
                    const hasCoordinates = data?.locations;
                    return `$${getExistingTotalRateUSD(data, hasCoordinates)}`;
                }
                else{
                    return 'N/A';
                }
            }
        },
        { 
            field: 'id', 
            headerName: '', 
            width: 50,
            renderCell: (params) => {
                return <Stack
                    direction='row'
                    alignItems='center'
                    height='100%'
                >
                    <IconButton aria-label="view" size="small" onClick={() => viewTourDetails(params.id)}>
                        <Tooltip title="View">
                            <VisibilityIcon fontSize="small"/>
                        </Tooltip>
                    </IconButton>
                </Stack>
            }
        }
    ];

    const [showDetails, setShowDetails] = useState(false);

    const updatePagination = useCallback((model, details) => {
        console.log(model.page);
        console.log(model.pageSize);

        changePageAndSize(model.page, model.pageSize);
    }, []);

    const selectRow = useCallback((rowModel, details) => {
        const rowId = rowModel.row.id;

        viewTourDetails(rowId);
    }, [viewTourDetails]);

    useEffect(() => {
        if(selectedTour){
            setShowDetails(true);
        }
    }, [selectedTour, showDetails]);

    const closeDetails = useCallback(() => {
        setShowDetails(false);
        setSelectedTour(false);
    }, []);

    return (
        <>
            <Paper sx={{ width: '100%' }}>
                <DataGrid
                    rows={tripData}
                    columns={columns}
                    rowCount={totalPages}
                    initialState={{ 
                        pagination: {
                            paginationModel: { page: page, pageSize: pageSize }
                        }
                    }}
                    pageSizeOptions={[25, 50, 100]}
                    pagination
                    paginationMode="server"
                    sx={{ 
                        border: 0,
                        '& .MuiDataGrid-cell:focus': {
                            outline: 'none',
                        },
                        '& .MuiDataGrid-cell:focus-within': {
                            outline: 'none',
                        },
                        // Optional: remove the outline from column headers when focused
                        '& .MuiDataGrid-columnHeader:focus': {
                            outline: 'none',
                        },
                        '& .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        }
                    }}
                    disableColumnMenu
                    disableColumnSorting
                    loading={dataLoading}
                    onPaginationModelChange={updatePagination}
                    onRowClick={selectRow}
                />
            </Paper>

            {/* <ButtonComponent 
                label='Clear All'
                onClick={clearAllRequest}
                sx={{
                    mt: {xs: 3, md: 5},
                    display: tripData.length > 0 ? 'flex' : 'none'
                }}
                variant="outlined"
                inLoading={isLoadingDeleteAllTours}
                startIcon={<DeleteForeverIcon sx={{color: 'red'}}/>}
            /> */}

            {/* View Details */}
            <DialogComponent 
                open={showDetails}
                body={
                    <>
                        <CalculatorResults 
                            backToFilterView={() => {}}
                            summaryData={selectedTour}
                            loadAllTours={loadAllTours}
                            modelViewClose={closeDetails}
                            sx={{
                                width: {xs: '100%', md: '75vw', lg: '50vw'}
                            }}
                        />
                    </>
                }
                handleClose={closeDetails}
                hideAction
                size="xl"
            />
        </>
    );
}


